'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocator = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PickupLocator, _React$Component);

  function PickupLocator(props, context) {
    (0, _classCallCheck3.default)(this, PickupLocator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PickupLocator.__proto__ || (0, _getPrototypeOf2.default)(PickupLocator)).call(this, props, context));

    _this.handleWindowSizeChange = function () {
      _this.setState({ width: window.innerWidth });
    };

    _this.state = {
      width: window.innerWidth
    };
    return _this;
  }

  (0, _createClass3.default)(PickupLocator, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.width >= this.props.maxSize) {
        return this.props.large;
      }

      return this.props.small;
    }
  }]);
  return PickupLocator;
}(_react2.default.Component), _class.propTypes = {
  small: _react.PropTypes.element,
  large: _react.PropTypes.element,
  maxSize: _react.PropTypes.number
}, _temp);
exports.default = PickupLocator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ResponsiveLayoutSelection/index.js
// module id = 2503
// module chunks = 0